import { render, staticRenderFns } from "./trsHeader.vue?vue&type=template&id=06f0c542&scoped=true"
import script from "./trsHeader.vue?vue&type=script&lang=js"
export * from "./trsHeader.vue?vue&type=script&lang=js"
import style0 from "./trsHeader.vue?vue&type=style&index=0&id=06f0c542&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f0c542",
  null
  
)

export default component.exports